
export const ADD_VIEW_BATCHES ="ADD_VIEW_BATCHES";
export function addViewBatches(updates){
    return {
      type: ADD_VIEW_BATCHES,
      payload: updates
    }
  }

  export const SET_STATUS_CARD_INDEX ="SET_STATUS_CARD_INDEX";
export function setStatusCardIndex(index){
    return {
      type: SET_STATUS_CARD_INDEX,
      payload: index
    }
  }




// WEBPACK FOOTER //
// ./src/app/batch_status/status_card_view/actions.js